if (!customElements.get("mini-checkout")) {
  customElements.define(
    "mini-checkout",
    class MiniCheckout extends HTMLElement {
      constructor() {
        super();

        this.expandButton = this.querySelector(".expand-button");
        if (!this.expandButton) return;

        this.boundToggleExpand = this.toggleExpand.bind(this);
        this.expandButton.addEventListener("click", this.boundToggleExpand);

        // Listen for variant and quantity change events
        this.boundOnChange = this.onChange.bind(this);
        this.addEventListener("change", this.boundOnChange);
      }

      disconnectedCallback() {
        if (this.boundToggleExpand)
          this.expandButton.removeEventListener(
            "click",
            this.boundToggleExpand,
          );
        if (this.boundOnChange)
          this.removeEventListener("change", this.boundOnChange);
      }

      /**
       * Toggle expand/collapse state
       */
      toggleExpand() {
        this.classList.toggle("has-expand");
        this.expandButton.setAttribute(
          "aria-expanded",
          this.classList.contains("has-expand"),
        );
      }

      /**
       * Sync mini-checkout input changes to the main product form
       * @param event
       */
      onChange(event) {
        const inputElement = event.target;
        if (!inputElement) return;

        const targetId = inputElement.dataset.target;
        if (!targetId) return;

        const targetInputElement = document.getElementById(targetId);
        if (!targetInputElement) return;

        if (
          targetInputElement.tagName === "INPUT" &&
          targetInputElement.type === "radio"
        ) {
          // Handle radio inputs
          targetInputElement.checked = true;
        } else {
          // Handle other inputs (select, text, etc.)
          targetInputElement.value = inputElement.value;
        }

        // Dispatch change event to sync with the main form
        targetInputElement.dispatchEvent(
          new Event("change", { bubbles: true }),
        );
      }
    },
  );
}
